<template>
  <v-container>
    <template v-if="checkParam">
      <v-card>
        <v-card-title class="headline"
          >Sorry , your order has expired</v-card-title
        >
        <v-card-text
          >Please dont press back button while placing the order,choose your
          template again to place the order</v-card-text
        >
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="success"
            :to="{ name: 'shortlist', params: { id: $store.state.userId } }"
            >Shortlist</v-btn
          >
          <v-btn color="primary" to="/explore-websites"
            >Explore Web Templates</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
    <template v-else>
      <v-layout row-wrap>
        <p class="title error--text">
          Total Amount: {{ $store.state.currencySymbol
          }}{{ calculateTotalAmount }}
        </p>
        <v-badge color="success" right>
          <template v-slot:badge>
            <v-icon dark>
              mdi-check
            </v-icon>
          </template>
        </v-badge>
      </v-layout>

      <v-stepper v-model="step" vertical>
        <v-stepper-header>
          <v-stepper-step class="twhite--text" step="1" :complete="step > 1"
            >Technology
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step class="twhite--text" step="2" :complete="step > 1"
            >Domain</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step class="twhite--text" step="3"
            >Place Order</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-alert class="white--text" :color="step1Type">{{
              step1
            }}</v-alert>
            <v-text-field
              label="Enter your Project Name"
              v-model="projectName"
              required
            ></v-text-field>

            <v-text-field
              label="Template"
              v-model="template"
              readonly
              required
            ></v-text-field>
            <v-text-field
              label="Technology"
              v-model="technology"
              readonly
              required
            ></v-text-field>
            <v-text-field
              label="Website Type"
              v-model="websiteType"
              readonly
              required
            ></v-text-field>

            <v-btn rounded color="primary" @click.native="validateStep1"
              >Continue</v-btn
            >
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-alert class="white--text" :color="step3Type">{{
              step3
            }}</v-alert>
            <v-switch
              v-model="hasDomain"
              :label="`Do you have a domain?`"
            ></v-switch>
            <template v-if="hasDomain">
              <v-text-field
                v-model="domainName"
                label="Domain Name"
                required
              ></v-text-field>
              <v-select
                v-model="dnsName"
                :items="hosts"
                menu-props="auto"
                hide-details
                label="Domain Registrator"
                single-line
              ></v-select>
            </template>
            <v-flex ma-4>
              <v-btn rounded text @click.native="step = 1">Previous</v-btn>
              <v-btn rounded color="primary" @click.native="validateStep2"
                >Continue</v-btn
              >
            </v-flex>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-textarea
              v-model="comments"
              label="Leave your comments or instructions"
              required
            ></v-textarea>

            <v-flex ma-4>
              <v-btn rounded text @click.native="step = 2">Previous</v-btn>
              <v-dialog rounded v-model="dialog" persistent max-width="425">
                <template v-slot:activator="{ on }">
                  <v-btn rounded pa-2 color="primary" v-on="on">Order</v-btn>
                </template>
                <v-card>
                  <v-img
                    :src="require('@/assets/logo.png')"
                    height="100"
                    width="200"
                    class="mx-auto"
                    contain
                  >
                  </v-img>
                  <v-progress-linear
                    indeterminate
                    color="primary"
                    :active="activeBar"
                  ></v-progress-linear>

                  <v-card-title>{{ cardTitle }} </v-card-title>
                  <v-card-text>
                    <v-flex v-if="beforePay">
                      <h4>
                        Total Amount Payable: {{ $store.state.currencySymbol }}
                        {{ calculateTotalAmount }}
                      </h4>
                    </v-flex>
                    <v-flex v-else>
                      <h4>{{ payMessage }}</h4>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <v-flex>
                      <v-btn
                        rounded
                        color="primary"
                        :disabled="clicked"
                        v-on:click="submit"
                        >Pay</v-btn
                      >
                      <v-btn rounded color="accent" v-on:click="setValues"
                        >Close</v-btn
                      >
                    </v-flex>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </v-container>
</template>

<script>
import { functions } from "@/Firebase";
export default {
  name: "WebsiteForm",
  data: () => ({
    activeBar: false,
    beforePay: true,
    cardTitle: "Thanks for choosing us",
    dialog: false,
    step: 1,
    clicked: false,
    totalAmount: 0,
    payMsg: "Please wait,your payment is being processed",
    websiteType: "CMS",
    template: "",
    projectName: "",
    step1: "Please enter a project name for your project",
    step1Type: "primary",
    step3: "If you have purchased domain name(websitename),please enter it",
    step3Type: "primary",
    noParam: false,
    technology: "",
    hasDomain: true,
    domainName: "",
    dnsName: "",
    productId: "",
    typeId: 1,
    comments: "",
    hosts: ["GoDaddy", "BlueHost", "NameCheap", "HostGator", "Others"],
    orderId: ""
  }),
  props: {
    web: {
      type: Object
    }
  },
  mounted() {
    if (this.web == null) {
      this.noParam = true;
    } else {
      this.technology = this.web.technology;
      this.template = this.web.name;
      this.productId = this.web.id;
      if (this.productId <= 500) {
        this.typeId = 1;
        this.websiteType = "CMS";
      } else {
        this.typeId = 2;
        this.websiteType = "Static Site";
      }
      if (this.$store.state.currency == "INR") 
          this.totalAmount = this.web.INR;
      else if (this.$store.state.currency == "AUD") 
          this.totalAmount = this.web.AUD;
      else if (this.$store.state.currency == "PHP") 
          this.totalAmount = this.web.PHP;
      else this.totalAmount = this.web.USD;
    }
  },

  computed: {
    checkParam() {
      return this.noParam;
    },
    calculateTotalAmount() {
      return String(this.totalAmount);
    },
    payMessage() {
      return this.payMsg;
    }
  },
  methods: {
    setValues() {
      this.clicked = false;
      this.beforePay = true;
      this.activeBar = false;
      this.dialog = false;
    },
    addFeature(id) {
      if (this.featureSelected.includes(id))
        this.totalAmount += this.wordpress[id - 1].price;
      else this.totalAmount -= this.wordpress[id - 1].price;
    },
    validateStep1() {
      if (this.projectName == "") {
        this.step1 = "Please enter the project name";
        this.step1Type = "accent";
        return (this.step = 1);
      } else {
        this.step1 = "";
        this.step1Type = "";
        return (this.step = 2);
      }
    },
    validateStep2() {
      if (this.hasDomain == true) {
        if (this.domainName == "" || this.dnsName == "") {
          this.step3Type = "accent";
          this.step3 = "Please fill your domain details properly";
          return (this.step = 2);
        } else {
          return (this.step = 3);
        }
      } else {
        return (this.step = 3);
      }
    },

    submit() {
      var vm = this;
      this.clicked = true;
      this.activeBar = true;
      this.beforePay = false;
      this.payMsg = "Please wait,the payment gateway will open in few seconds";
      var getOrderId = functions.httpsCallable("getOrderId");
      getOrderId({
        currency: this.$store.getters.currency,
        amount: this.totalAmount * 100,
        uid: this.$store.getters.userId
      })
        .then(result => {
          this.payMsg = "Processing your payment";
          var userId = this.$store.state.userId;
          var today = new Date();
          var mon = today.getMonth() + 1;
          var nextDate = today.getDate();
          if (nextDate == 29 && mon == 2 && today.getFullYear() % 4 == 0)
            nextDate == 28;
          //good for 80 yrs
          var expDate = today.getFullYear() + 1 + "-" + mon + "-" + nextDate;
          var oDate = today.getFullYear() + "-" + mon + "-" + today.getDate();
          oDate = String(oDate);
          expDate = String(expDate);
          var orderDetails = {
            displayName: this.$store.state.displayName,
            project_name: this.projectName,
            order_id: result.data.id,
            user_id: userId,
            total_amount: this.totalAmount * 100,
            currency: this.$store.getters.currency,
            comments: this.comments,
            status: "paid",
            template: this.template,
            technology: this.technology,
            type: this.websiteType,
            lifecycle: [
              { name: "Data Collection", status: "In Progress", date: oDate },
              { name: "Design & Analysis", status: "Pending", date: null },
              { name: "Build & Optimize", status: "Pending", date: null },
              { name: "Deployment", status: "Pending", date: null }
            ],
            prod_id: this.productId,
            start_date: oDate,
            domain_name: this.domainName,
            dns_name: this.dnsName,
            type_id: this.typeId,
            user_type: 1,
            host_type: 1,
            expiry_at: expDate,
            subscription_type: 3,
            payment_gateways: "razorpay"
          };

          var options = {
            key: "rzp_live_TNj6aTAUEyIxLR", // Enter the Key ID generated from the Dashboard
            currency: this.$store.state.currency,
            name: this.web.name,
            amount: this.totalAmount * 100,
            callback_url: "https://saascadetech.com",
            order_id: result.data.id,
            payment_capture: 1,
            description: this.web.technology,
            image: "./assets/logo.png",
            //This is a sample Order ID. Create an Order using Orders API. (https://razorpay.com/docs/payment-gateway/orders/integration/#step-1-create-an-order). Refer the Checkout form table given below
            handler: function(response) {
              var insertOrderWebsite = functions.httpsCallable(
                "insertOrderWebsite"
              );
              insertOrderWebsite({
                orderDetails: orderDetails,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id
              }).then(res => {
                vm.payMsg = res.data.msg;
                vm.cardTitle = "Verifying payment ID ,please wait";
              });
              var verifySignature = functions.httpsCallable("verifySignature");

              verifySignature({
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature
              }).then(res => {
                vm.cardTitle = res.data.msg;
                vm.payMsg = "Completed";
                vm.beforePay = true;
                vm.dialog = false;
                window.location.href = "/orders-website";
              });
            },
            prefill: {
              name: this.$store.getters.displayName,
              email: this.$store.getters.email,
              contact: this.$store.getters.phNumber
            },
            notes: {
              user_id: this.$store.getters.userId,
              project_name: this.projectName,
              total_amount: this.totalAmount * 100,
              currency: this.$store.getters.currency,
              status: this.status,
              user_type: 1,
              prod_id: this.productId,
              type_id: this.typeId,
              domain_name: this.domainName,
              dns_name: this.dnsName,
              subscription_type: 3
            },
            theme: {
              color: "#5856E8"
            }
          };
          var rzp1 = new window.Razorpay(options);
          rzp1.open();
        })
        .catch(error => {
          alert("Error " + error);
        });
    }
  }
};
</script>

<style></style>
